import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-search-sidebar-no-results',
  templateUrl: './search-sidebar-no-results.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSidebarNoResultsComponent {
  @Input() public collectionName: string;

  constructor(private translateService: TranslateService) {}

  public get errorMessage(): string {
    return this.translateService.instant('LearningSearch_NoSidebarFormat', {
      type: this.collectionName,
    });
  }
}
